import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { reduce, Subject } from 'rxjs';


@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent {

  activeSection: 'profile' | 'country' | 'subscription' | null = null;
  profileData: any;
  profileImg: string = '';
  profGen: any;

  constructor(
    private dialog: MatDialog, private sanitizer: DomSanitizer, private fb: FormBuilder,
    private auth: AuthService, private data: DataService, private router: Router, private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // console.log('settings')
    this.getProfile();
    this.getCitizenships();
    this.activeSection = 'profile';
  }

  ngOnDestroy() {
    document.body.style.overflow = 'auto'; // re-enable when you leave
  }
  getProfile() {
    this.auth.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = user.data?.profile;
    })
    // this.auth.profile_details().subscribe((res:any) =>{
    //   //this.profGen = res[0];
    // })
    this.auth.get_image().subscribe((img: any) => {
      this.profileImg = img.data?.imageUrl;
    })
  }
  getCitizenships(){
    this.auth.get_citizenship().subscribe((user: any) => {
      //this.profileData = user.data?.profile;
    })
  }

  onLogout() {
    // Preserve "Remember Me" data before clearing localStorage
    const rememberedEmail = localStorage.getItem('remembered_email');
    const rememberedPassword = localStorage.getItem('remembered_password');
    const rememberedChecked = localStorage.getItem('remembered_checked');

    // Clear localStorage but keep "Remember Me" credentials
    localStorage.clear();
    //sessionStorage.clear();

    if (rememberedChecked === 'true') {
      localStorage.setItem('remembered_email', rememberedEmail || '');
      localStorage.setItem('remembered_password', rememberedPassword || '');
      localStorage.setItem('remembered_checked', rememberedChecked);
    }

    this.router.navigate(['/login']);
  }

}
